var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import {} from '@folkjs/dom/ClientRectObserver';
import { ReactiveElement, css, property, state, } from '@folkjs/dom/ReactiveElement';
import { FolkObserver, parseDeepCSSSelector } from './folk-observer';
const folkObserver = new FolkObserver();
// TODO: use mutation observer to track the addition an removal of elements
export class FolkBaseSet extends ReactiveElement {
    constructor() {
        super(...arguments);
        this.#sourcesMap = new Map();
        this.sourceElements = new Set();
        this.#slot = document.createElement('slot');
        // we might not need to react to the first slot change
        this.#onSlotchange = () => this.#observeSources();
        this.#sourcesCallback = (entry) => {
            this.#sourcesMap.set(entry.target, entry.contentRect);
            this.requestUpdate('sourcesMap');
        };
    }
    static { this.styles = css `
    :host {
      display: block;
      position: absolute;
      inset: 0;
      pointer-events: none;
      overflow: hidden;
      scrollbar-width: none;
    }
    :host::-webkit-scrollbar {
      display: none;
    }

    ::slotted(*) {
      pointer-events: auto;
      z-index: 1;
    }
  `; }
    #sourcesMap;
    get sourcesMap() {
        return this.#sourcesMap;
    }
    get sourceRects() {
        return Array.from(this.#sourcesMap.values());
    }
    #slot;
    createRenderRoot() {
        const root = super.createRenderRoot();
        root.append(this.#slot);
        this.#slot.addEventListener('slotchange', this.#onSlotchange);
        return root;
    }
    willUpdate(changedProperties) {
        if (changedProperties.has('sources')) {
            this.#observeSources();
        }
        else if (changedProperties.has('sourceElements')) {
            const oldElements = changedProperties.get('sourceElements') || new Set();
            const elementsToObserve = this.sourceElements.difference(oldElements);
            const elementsToUnobserve = oldElements.difference(this.sourceElements);
            this.#unobserveSources(elementsToUnobserve);
            for (const el of elementsToObserve) {
                folkObserver.observe(el, this.#sourcesCallback);
            }
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.#unobserveSources(this.sourceElements);
    }
    // we might not need to react to the first slot change
    #onSlotchange;
    #observeSources() {
        const childElements = new Set(this.children);
        const elements = this.sources ? parseDeepCSSSelector(this.sources) : [];
        const elementsMap = new Map(elements);
        const sourceElements = new Set(elements.map((el) => el[0])).union(childElements);
        const elementsToObserve = sourceElements.difference(this.sourceElements);
        const elementsToUnobserve = this.sourceElements.difference(sourceElements);
        this.#unobserveSources(elementsToUnobserve);
        for (const el of elementsToObserve) {
            folkObserver.observe(el, this.#sourcesCallback, { iframeSelector: elementsMap.get(el) });
        }
        this.sourceElements = sourceElements;
    }
    #sourcesCallback;
    #unobserveSources(elements) {
        for (const el of elements) {
            this.#sourcesMap.delete(el);
            this.sourceElements.delete(el);
            folkObserver.unobserve(el, this.#sourcesCallback);
        }
    }
    addElement(element) {
        if (this.sourceElements.has(element))
            return;
        const set = new Set(this.sourceElements);
        set.add(element);
        this.sourceElements = set;
    }
    removeElement(element) {
        if (!this.sourceElements.has(element))
            return;
        const set = new Set();
        this.sourceElements.forEach((el) => {
            if (el !== element)
                set.add(el);
        });
        this.sourceElements = set;
    }
}
__decorate([
    property({ reflect: true })
], FolkBaseSet.prototype, "sources", void 0);
__decorate([
    state()
], FolkBaseSet.prototype, "sourceElements", void 0);
//# sourceMappingURL=folk-base-set.js.map